<template>
  <div @click="$emit('showDetail', item.id)" class="pkg pkg-new">
    <div
      v-if="item.min_price && item.activity_price != item.origin_price"
      class="top"
    >
      {{ item.min_price }}
    </div>
    <div class="pkg-title">{{ item.name }}</div>
    <p v-if="item.description" class="detail">{{ item.description }}</p>
    <div class="bottom">
      <div class="price-wrap">
        <span class="lower-price DharmaTypeBebasKai">
          <span class="sign">¥</span>
          <span class="num">{{ item.activity_price }}</span>
        </span>
        <span
          v-if="+item.origin_price !== +item.activity_price"
          class="DharmaTypeBebasKai price"
        >
          原价：¥{{ item.origin_price }}
        </span>
      </div>
      <div class="btn" @click.stop="toOrder">预约</div>
    </div>
  </div>
</template>

<script>
import { activityInfo, activityJoinCheck } from 'api/platform/homepage.js'
import { EventBus } from 'component/platform/homepage/eventBus.js'
export default {
  components: {},
  props: {
    item: {
      type: Object,
      defualt: () => {}
    }
  },
  data() {
    return {
      pageData: {}
    }
  },
  methods: {
    toOrder() {
      const { activity_type, url, id } = this.item
      this.$emit('toOrder', this.item)
      if (['theme', 'other'].includes(activity_type) && url) {
        const { cid, channel_flag } = this.$route.query
        activityInfo({
          id: id,
          cid,
          channel_flag
        }).then(res => {
          this.pageData = res.data
          this.joinCheck(id)
        })
      } else {
        this.emitEvent({ activity_id: id })
      }
    },
    joinCheck(id) {
      const activity_id = id
      const { cid, channel_flag } = this.$route.query
      activityJoinCheck({ activity_id }).then(res => {
        const { code, message, data } = res
        const { basic: { teacher_id } = {} } = this.pageData
        const teacherId = this.$route.params.userId

        if (code === 0) {
          this.toOrderPage(teacherId, activity_id, cid, channel_flag)
        } else if (code === 40001) {
          const { isYixinliApp, isZiXunApp } = this.$platform
          if (isYixinliApp || isZiXunApp || this.isNativeLoginWebviewMp) {
            // window.location.href = 'yixinli://open_user_login'
            this.toLogin(teacher_id, activity_id, cid, channel_flag)
          } else {
            this.toOrderPage(teacherId, activity_id, cid, channel_flag)
          }
        } else if (code === 40003 && data?.order_id) {
          this.$toast({
            text: message,
            time: 1500,
            callback: () => {
              this.routerToStaic({
                path: `/resv-order-detail-user?id=${data.order_id}&hideNavigationBar=1&fromUpPkg=1`
              })
            }
          })
        } else {
          return this.$toast(message)
        }
      })
    },
    toOrderPage(teacher_id, activity_id, cooperation_channel_id, channel_flag) {
      this.routerPushWithoutNav(
        {
          path: '/consult-order-page',
          query: {
            to_user_id: teacher_id || '',
            xlt_studio_id: this.$route.query.xlt_studio_id || '',
            activity_id,
            cooperation_channel_id,
            channel_flag,
            fromUpPkg: 1,
            other_instructions: this.$route.params.userId
          }
        },
        `https://static.xinli001.com/msite/index.html`,
        true,
        'hash'
      )
    },
    emitEvent(params = {}) {
      EventBus.$emit('toZxOrder', params)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~lib/scss/functions';
.pkgs-wrap {
  display: flex;
  padding-top: 40px;
  overflow: scroll;
  .pkg {
    position: relative;
    width: 600px;
    height: 240px;
    padding: 34px 30px 0;
    background: linear-gradient(
      180deg,
      rgba(255, 247, 245, 0.4) 0%,
      rgba(255, 246, 245, 0.4) 0%,
      rgba(255, 247, 246, 0.4) 0%,
      rgba(255, 245, 229, 0.4) 0%,
      rgba(255, 233, 209, 0.4) 100%
    );
    border-radius: 20px;
    box-sizing: border-box;
    border: 2px solid rgba(255, 221, 186, 0.4);
    .top {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      padding: 0 10px;
      height: 28px;
      background: #fff1e2;
      border-radius: 20px 0px 20px 0px;

      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ff745b;
      line-height: 28px;
    }
    .center {
      display: flex;
      justify-content: space-between;
      .pkg-title {
        min-width: 394px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 700;
        color: rgba(33, 37, 45, 1);
        line-height: 44px;
        @include limitLine(2);
        margin-right: 30px;
      }
      .btn {
        flex-shrink: 0;
        width: 105px;
        height: 52px;
        background: linear-gradient(225deg, #869bff 0%, #627dff 100%);
        border-radius: 27px;
        text-align: center;
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 52px;
      }
    }
    p.detail {
      width: calc(100% - 105px);
      height: 36px;
      opacity: 1;
      font-size: 24px;
      line-height: 36px;
      color: rgba(108, 121, 140, 1);
      @include limitLine(1);
    }
    .bottom {
      position: absolute;
      bottom: 20px;
      right: 30px;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      .price {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #9da3ac;
        margin-right: 16px;
        text-decoration: line-through;
      }

      .lower-price {
        font-size: 42px;
        font-family: DharmaTypeBebasKai;
        color: #ffa202;
        font-weight: 700;
        line-height: 42px;
        span {
          font-size: 30px;
          line-height: 30px;
        }
      }
    }
  }
  .pkg.pkg-new {
    position: relative;
    width: 600px;
    height: 295px;
    padding: 44px 30px 0;
    background: #f8f9ff;
    border-radius: 20px;
    box-sizing: border-box;
    border: none;
    flex-shrink: 0;
    .top {
      display: flex;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      // display: inline-block;
      height: 32px;
      border-radius: 20px 0px 20px 0px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      // line-height: 28px;

      padding: 0 20px;
      font-size: 20px;
      color: #ffffff;
      // line-height: 32px;
      background: linear-gradient(
        225deg,
        rgba(161, 177, 255, 0.6) 0%,
        rgba(98, 125, 255, 0.6) 100%
      );
    }
    .pkg-title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 700;
      color: #21252d;
      line-height: 46px;
      @include limitLine(2);
    }
    p.detail {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #6c798c;
      line-height: 36px;
      width: 540px;
      opacity: 1;
      margin-top: 10px;
      @include limitLine(1);
    }
    .bottom {
      position: absolute;
      width: calc(100% - 60px);
      bottom: 30px;
      right: 30px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .price-wrap {
        display: flex;
        .price {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #9da3ac;
          margin-right: 16px;
          text-decoration: line-through;
          margin-left: 16px;
        }

        .lower-price {
          display: flex;
          align-items: baseline;
          color: #6982fa;
          font-weight: 700;
          .num {
            font-size: 42px;
          }
          .sign {
            font-size: 30px;
          }
        }
      }
      .btn {
        flex-shrink: 0;
        width: 115px;
        height: 52px;
        background: linear-gradient(225deg, #869bff 0%, #627dff 100%);
        border-radius: 27px;
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 52px;
        text-align: center;
      }
    }
  }
}
</style>
